const optionColor =
	'{{for (var i=0; i < colors.length; i++) { }}' +
	'<span class="color-item option {{=colors[i].key.toLowerCase()}} {{=colors[i].key === selected?"active":""}}" data-color="{{=colors[i].key}}" title="{{=colors[i].label }}"><span class="icon color-{{=colors[i].key.toLowerCase()}}"></span></span>' +
	'{{ } }}' +
	'{{ if(customOptionTitle) { }} <span class="color-item option js-custom-option business-christmas" data-lightbox-opener="design-service-popup" title="{{=customOptionTitle}}"><span class="icon"></span></span> {{ } }}';

export default optionColor;
